import React, { useState } from 'react';
import { Edit, Trash2, Eye } from 'lucide-react';
import Button from '../ui/Button';
import EditItemModal from './EditItemModal';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import ItemDetailsModal from './ItemDetailsModal';
import { toTitleCase, toUppercase, toSentenceCase } from '../../utils/dataUtils';
import { deleteItem } from '../../services/api';

function InventoryTable({ inventory, onEdit, refresh, onDelete, itemGroups }) {
    const [editingItem, setEditingItem] = useState(null);
    const [deletingItemId, setDeletingItemId] = useState(null);
    const [viewingItem, setViewingItem] = useState(null);

    const options = {
        year: '2-digit',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    };

    const userRole = localStorage.getItem('userRole');

    return (
    <>
        <div className="flex relative flex-column bg-white shadow-md rounded-lg h-[calc(90vh-108px)] overflow-auto">
            <table className="w-full">
            {/* <thead className="bg-gray-50 dark:bg-gray-800"> */}
            <thead className="bg-gray-200">
                <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Quantity</th>
                {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Selling Price</th> */}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Group</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Last Updated</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-600 uppercase tracking-wider">Actions</th>
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
                {inventory.map((item) => (
                <tr key={item._id} className='hover:bg-sky-100'>
                    <td className="px-6 py-1.5 text-sm font-medium text-gray-900" onClick={() => setViewingItem(item)}>
                        {toTitleCase(item.name)}<br />
                        {item.altname ? (
                        <span className='text-xs text-gray-500'>alt: {item.altname}</span>
                        ) : (
                            <></>
                        )}
                    </td>
                    <td className="px-6 py-1.5 text-sm text-gray-500">{item.quantity} {item.unitType}</td>
                    {/* <td className="px-6 py-4">₹{item.price || 'NA' }</td> */}
                    {/* <td className="px-6 py-4">₹{item.price.toFixed(2)}</td> */}
                    <td className="px-6 py-1.5 text-sm text-gray-500">{item.group}</td>
                    <td className="px-6 py-1.5">
                    {Number(item.quantity) <= Number(item.lowStockThreshold) ? (
                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                        Low Stock
                        </span>
                    ) : (
                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        In Stock
                        </span>
                    )}
                    </td>
                    <td className="px-6 py-1.5 text-sm text-gray-500">
                        {new Date(item.updatedAt).toLocaleDateString('en-IN', options)}
                    </td>
                    <td className="px-6 py-1.5 whitespace-nowrap text-center text-sm font-medium">
                        <Button variant="outline" size="sm" onClick={() => setViewingItem(item)}>
                            <Eye className="h-3 w-3" />
                            <span className="sr-only">View</span>
                        </Button>
                        <Button size="sm" onClick={() => setEditingItem(item)}>
                            <Edit className="h-3 w-3" />
                            <span className="sr-only">Edit</span>
                        </Button>
                        {userRole !== 'item_user' ? (
                        <Button variant="destructive" size="sm" onClick={() => setDeletingItemId(item._id)}>
                            <Trash2 className="h-3 w-3" />
                            <span className="sr-only">Delete</span>
                        </Button>
                        ) : (
                        <></>
                        )}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>

        {editingItem && (
            <EditItemModal
            item={editingItem}
            onClose={() => setEditingItem(null)}
            onSave={(editedItem) => {
                onEdit(editedItem);
                refresh();
                setEditingItem(null);
            }}
            itemGroups={itemGroups}
            />
        )}

        {deletingItemId && (
            <DeleteConfirmationModal
            method={deleteItem}
            itemId={deletingItemId}
            onClose={() => setDeletingItemId(null)}
            onConfirm={() => {
                // onDelete(deletingItemId);
                refresh();
                setDeletingItemId(null);
            }}
            />
        )}
        
        {viewingItem && (
            <ItemDetailsModal
            item={viewingItem}
            onClose={() => setViewingItem(null)}
            />
        )}

    </>
    );
}

export default InventoryTable;